import React from "react";
import { Radio } from "./Radio";

interface OptionCardProps {
  selected: boolean;
  onSelect: () => void;
  title: React.ReactNode;
  detail: React.ReactNode;
  /** Shown but not choosable; `detail` says why. */
  disabled?: boolean;
  /** A larger choice that leads with its icon in place of the radio. */
  icon?: React.ReactNode;
}

/** One choice inside a `role="radiogroup"` container: a button that IS the
 *  radio, so the whole card is the hit target and the selection reads as an
 *  accent border rather than browser radio chrome. */
export const OptionCard: React.FC<OptionCardProps> = ({
  selected,
  onSelect,
  title,
  detail,
  disabled = false,
  icon,
}) => (
  <button
    type="button"
    role="radio"
    aria-checked={selected}
    disabled={disabled}
    onClick={onSelect}
    className={`flex w-full items-start gap-2 rounded-app border px-3 py-2 text-left cursor-pointer disabled:cursor-not-allowed disabled:opacity-55 ${
      selected
        ? "border-accent bg-accent-subtle"
        : "border-border enabled:hover:bg-list-hover"
    }`}
  >
    {icon ? (
      <span
        className={`flex flex-none items-center justify-center rounded-app border ${selected ? "border-accent text-accent" : "border-border text-fg-muted"}`}
        style={{ width: "2rem", height: "2rem" }}
      >
        {icon}
      </span>
    ) : (
      <Radio selected={selected} className="mt-0.5" />
    )}
    <span className="flex min-w-0 flex-1 flex-col gap-0.5">
      <span className="flex items-center gap-1.5 text-fg-medium">{title}</span>
      <span className="text-fg-muted-regular-small">{detail}</span>
    </span>
  </button>
);
